import HeroSection from "../components/Consultancies/HeroSection"
import OurConsultantsSection from "../components/Consultancies/OurConsultantsSection"
import OurStudentsSection from "../components/Consultancies/OurStudentsSection"
import AnimatedSection from "../components/Shared/AnimatedSection"
const Consultation = () => {
    return (
        <>
        <HeroSection/>
        <AnimatedSection>
            <OurStudentsSection/>
        </AnimatedSection>
        <AnimatedSection>
            <OurConsultantsSection/>
        </AnimatedSection>
        </>
    )
}

export default Consultation